var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Los colores","audio2":"../mp3/PrimariaD/05PD.mp3","cover":"../img/4.jpg","name":"Primaria D - Lección #5"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }